module.exports = __webpack_public_path__ + "img/sg.f90dc9c9.svg";